import { render, staticRenderFns } from "./OnlineEftposPayment.vue?vue&type=template&id=28aafa06&scoped=true&"
import script from "./OnlineEftposPayment.vue?vue&type=script&lang=js&"
export * from "./OnlineEftposPayment.vue?vue&type=script&lang=js&"
import style0 from "./OnlineEftposPayment.vue?vue&type=style&index=0&id=28aafa06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aafa06",
  null
  
)

export default component.exports